module.exports = __webpack_public_path__ + "static/AzoSans-Medium-d26e5f152af06634bf8e71b7e15a650a.eot";